const DIFFUSE_TEXTURES = [
  ['diffuse_tsrf_iso', 'tsrf_iso'],
  ['diffuse_tof_iso', 'tof_iso'],
  ['diffuse_tsrf_horizon', 'tsrf_horizon'],
  ['diffuse_tof_horizon', 'tof_horizon']
];

const MONTHLY_TEXTURES = [
  ['tsrf', 'tsrf'],
  ['tof', 'tof'],
  ['solarAccess', 'solarAccess']
];

export const isLoadableTextureSource = (source) => typeof source === 'string' && source.trim().length > 0;

export const buildTextureLoadPlan = (data = {}) => {
  const payload = data && typeof data === 'object' ? data : {};
  const plan = [];
  const diffuse = Array.isArray(payload.diffuse) ? payload.diffuse : [];

  DIFFUSE_TEXTURES.forEach(([name, month], index) => {
    if (isLoadableTextureSource(diffuse[index])) {
      plan.push({ name, month, source: diffuse[index] });
    }
  });

  MONTHLY_TEXTURES.forEach(([field, namePrefix]) => {
    const sources = Array.isArray(payload[field]) ? payload[field] : [];
    sources.forEach((source, month) => {
      if (isLoadableTextureSource(source)) {
        plan.push({ name: `${namePrefix}_${month}`, month, source });
      }
    });
  });

  return plan;
};
